@import (reference) '../../../../../../constants/spacing.module.less';

.return-voided-label-section {
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;
  justify-content: center;
  gap: @space-16;
  padding: @space-16;
  background: var(--default--background-color--16);
  border-color: var(--default--border-color--15);
}

.return-voided-label-section-title {
  color: var(--light--text-color--1);
}
